import { createFileRoute, defer, useParams } from '@tanstack/react-router';
import {
    emailDraftQueryOptions,
    emailRecipientsContactsQueryOptions,
    fromEmailsQueryOptions,
} from '@utils/queryOptions';
import EditEmailDraft from '@Views/Emails/drafts/edit';

export const Route = createFileRoute('/emails/drafts/$draftId/')({
    loader: opts => {
        const data = opts.context.queryClient.ensureQueryData(
            emailDraftQueryOptions(opts.params.draftId),
        );

        const fromEmails = defer(
            opts.context.queryClient.ensureQueryData(fromEmailsQueryOptions()),
        );

        const recipientsContacts = defer(
            opts.context.queryClient.ensureQueryData(
                emailRecipientsContactsQueryOptions(opts.params.draftId),
            ),
        );
    },
    component: () => {
        const { draftId } = useParams({});
        return <EditEmailDraft key={window.location.pathname} />;
    },
});
